import { render } from "./PoStatus.vue?vue&type=template&id=78564678&scoped=true"
import script from "./PoStatus.vue?vue&type=script&lang=js"
export * from "./PoStatus.vue?vue&type=script&lang=js"

import "./PoStatus.vue?vue&type=style&index=0&id=78564678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78564678"]])

export default __exports__